import React from 'react';
import {Container, Row, Col } from 'react-bootstrap';

import FormContact from './Form-contact'

const Contact = (props)=>{
	return(
		<Container fluid className="contact-wrapper" id={props.id}>
			<Row className="contact-form">
				<Col xs={12} md={8} >
					<FormContact />
				</Col>
			</Row>
		</Container>
	);
}

export default Contact;